import { IAPIClient } from '../api/client';
import axios from 'axios';

/** A received 4xx response is a definitive rejection; a missing response is ambiguous. */
export function isDefinitePaymentRejection(error: unknown): boolean {
  return axios.isAxiosError(error) && !!error.response && error.response.status >= 400 && error.response.status < 500;
}

export function localDateOnly(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** Sum active applications across every page; invoice totals alone omit earlier payments. */
export async function invoicePaymentSummary(api: Pick<IAPIClient, 'listPayments'>, invoiceId: string, invoiceTotal: string) {
  let page = 1;
  let paid = 0;
  let pages = 1;
  do {
    const result = await api.listPayments(page, 100, { invoiceId, status: 'ACTIVE' });
    paid += result.data.flatMap((payment) => payment.applications)
      .filter((application) => application.invoiceId === invoiceId)
      .reduce((sum, application) => sum + Number(application.amountApplied), 0);
    pages = result.pagination.pages;
    page += 1;
  } while (page <= pages);
  return { paid, remaining: Math.max(0, Number(invoiceTotal) - paid) };
}
